import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import { bannerPlaces, convertBanner, convertLocations } from '../../../services/banners'
import BannerPayment from './Payment'
import useToastContext from "../../../hooks/useToastContext"

import { Helmet } from "react-helmet-async"
import { BannerStatusBages, BannerActionButtons } from './common'
import { BannerPreview } from './Form'

import moment from "moment"

const bannerProperty = (banner, property, defaultValue) => {
    return banner.options && banner.options.settings && banner.options.settings[property] ? banner.options.settings[property] : defaultValue
}

const BannerPay = ({ match, history }) => {

    const { data, authServices, location, bannerServices } = useContext(AppContext)
    const { user } = data.app

    const addToast = useToastContext()

    const bannerId = match.params.id
    const title = "Purchase Banner Ad"

    const [ isChecked, setIsChecked ] = useState(false)

    const [ placement, setPlacement ] = useState(null)
    const [ banner, setBanner ] = useState(null)
    const [ rawBanner, setRawBanner ] = useState(null)
    const [ locations, setLocations ] = useState([])
    const [ categories, setCategories ] = useState([])
    const [ images, setImages ] = useState([])

    useEffect(() => {
        bannerServices.show(bannerId, {placement: 'y'}).then(res => {
            const _banner = res.banner
            const bannerPlacement = _banner.placements && _banner.placements[0] ? _banner.placements[0] : null
            var prefix = 'main_'

            if(_banner){
                setBanner(convertBanner(_banner))
                setRawBanner(_banner)
            }

            if(bannerPlacement){
                if(bannerPlacement.locations) setLocations(convertLocations(bannerPlacement.locations))
                if(bannerPlacement.categories && bannerPlacement.categories.length > 0){
                    setCategories(bannerPlacement.categories.map(item => item.id))
                    prefix = 'category_'
                }
            }

            const _placement = prefix + bannerPlaces.filter(item => item.type == _banner.type)[0].key
            setPlacement(_placement)

            setIsChecked(true)
        }).catch(res => {
            console.log('error')
            console.log(res)
            setIsChecked(true)
        })
    }, [])

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/banner/list', title: 'Banner ads list'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="me-3">
                                <h1 className="mt-0">
                                    <span className="me-2">#{bannerId} {title}</span>
                                    {rawBanner && <BannerStatusBages banner={rawBanner} />}
                                </h1>
                            </div>
                            <BannerActionButtons banner={rawBanner} page="pay" />
                        </div>

                        <BannerPayment
                            bannerId={bannerId}
                            banner={rawBanner}
                            onSuccess={() => {
                                history.push('/account/banner/view/' + bannerId)
                            }}
                            onError={() => {

                            }}
                        />

                        <BannerPreview banner={rawBanner} />

                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default BannerPay
